import { React, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Lottie from 'lottie-react';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

import MessageSendList from './MessageSendList';

// import KakaoTalkSpeechBubbleIcon from '../../../image/KakaoTalkSpeechBubbleIcon.png';
import SMSIcon from '../../../image/SMSIcon.png';
import LoadingAnimation from '../../../Animation/NewLoading.json';

export default function MessageSendHistoryView(props) {
  const { 
    today, 
    calcDateText, 
    data,
    selectedPartnerGym,
    isOpenPartnerGymSales, 
    isLoading, 
    setIsLoading 
  } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();
  const history = useHistory();

  const [totalSendCount, setTotalSendCount] = useState(0);

  // 데이터 세팅 //
  useEffect(() => {
    let totalCount = 0;

    for (let i = 0; i < data.length; i++) {
      totalCount += data[i].successCount;
    }

    setIsLoading(false);
    setTotalSendCount(totalCount);
  }, [data])

  // 발송 내역 클릭시 //
  function onClickData(data) {
    if (selectedPartnerGym === undefined || selectedPartnerGym.isMyStore) history.push('/notice/details/' + data.noticeId);
  }

  return (
    <TopLevelWrapper $isDark={isDark}>
      <InfoBox>
        <TitleWrapper>
          <Title>{calcDateText() + ' ' + t('statistics.message.messageSendHistory') + ' ( ' + data.length + t('statistics.countUnit') + ' )'}</Title>
        </TitleWrapper>
        <IconLineWrapper>
          <KakaoIconWrapper>
            <KakaoIconBox>
              <Image src={SMSIcon} />
            </KakaoIconBox>
            <KakaoTextBox>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subBackground} cursor='default'>{t('statistics.message.totalSendCount', { count: totalSendCount.toLocaleString('ko-KR') })}</Text>
            </KakaoTextBox>
          </KakaoIconWrapper>
          <DivisionLine/>
          <TotalPriceBox>
            <TotalPriceTextWrapper>
              <Text fontFamily='NotoSansKR-Medium' fontSize={15} color={theme.subText} cursor='default'>{(totalSendCount * 60).toLocaleString('ko-KR')}</Text>
              <Text fontFamily='NotoSansKR-Medium' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.won')}</Text>
            </TotalPriceTextWrapper>
          </TotalPriceBox>
        </IconLineWrapper>
        {
          isLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </AnimationBox>
            :
            <TotalInfoBox>
              {
                isOpenPartnerGymSales ?
                  <MessageSendList data={data} onClickData={onClickData} />
                  :
                  <NotOpenTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivate')}</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color={theme.subText} cursor='default'>{t('statistics.partnerGymPrivateDesc')}</Text>
                  </NotOpenTextWrapper>
              }
            </TotalInfoBox>
        }
      </InfoBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 24px 0px 24px 0px;

  width: 1020px;
  // height: 544px;

  margin-top: 38px;
  margin-bottom: 38px;

  border-radius: 30px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  background-color: ${props => props.theme.subBackground};
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  // width: 97.25%;
  width: 94.5%;
  // height: 544px;
`;

const TotalInfoBox = styled.div`
  display: flex;
  flex-drection: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 439px;
`;

const NotOpenTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const AnimationBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  z-index: 5;
  
  width: 100%;
  height: 439px;

  // background-color: rgba(0, 0, 0, 0.2);
  background-color: ${props => props.theme.subBackground};
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 160px;
  height: 160px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const Title = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  // margin: 28px 0 0 13px;
  margin: 0px;
  padding: 0px;
`;

const IconLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 26px;

  width: 100%;
`;

const KakaoIconWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 16px;
`;

const KakaoIconBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 42px;
  height: 42px;

  border-radius: 8px;
  background-color: ${props => props.theme.subKey};
`;

const KakaoTextBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 164px;
  height: 28px;

  border-radius: 8px;
  background-color: ${props => props.theme.subKey};
`;

const Image = styled.img`
  width: 30px;
  height: 28px;
`;

const TotalPriceBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 108px;
  height: 28px;

  border-radius: 8px;
  background-color: ${props => props.theme.line};
`;

const TotalPriceTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const DivisionLine = styled.div`
  display: flex;
  flex-direction: row;

  width: 607px;
  height: 1px;

  // margin: 0 16px 0 16px;
  // border: 1px solid #ECECEC;
  background-color: ${props => props.theme.line};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;